import React, { useEffect } from "react";
import ParticlesJS from "@tsparticles/react";
// import ParticlesParams from "../../config/particlesjs-config.json"
import { loadBubblesPreset } from "@tsparticles/preset-bubbles";


// const Particles = () => {
//   const options = {
//     preset: "bubbles",
//   }
//   const customInit = async (engine) => {
//     await loadBubblesPreset(engine)
//   }
//   return (
//     <ParticlesJS
//       className="absolute w-full h-full"
//       options={options}
//       init={customInit}
//     />
//   )
// }

// const Particles = () => {
//   console.log("Particles.tsxのコンソールログ");

//   return (
//     <div className="absolute w-full h-full" id="tsparticles"></div>
//   )
// }

// export default Particles



const ParticleComponent = () => {

  useEffect(() => {

    const initParticles = async () => {

      await loadBubblesPreset(tsParticles);

      await tsParticles.load({
        id: "tsparticles",
        options: {
          preset: "bubbles",
        },
      });

    };

    initParticles();

  }, []);

  return (
    <div
      id="tsparticles"
      className="absolute w-full h-full"
    />
  );
};

export default ParticleComponent;